import { jsx as c } from "react/jsx-runtime";
import { c as r } from "../../../clsx-OuTLNxxd.js";
const a = "_container_ekulv_29", s = {
  container: a,
  "is-fluid": "_is-fluid_ekulv_45"
};
function u({ isFluid: n = !1, children: i, className: o = "", ...t }) {
  const e = r(s.container, n && s["is-fluid"], o);
  return /* @__PURE__ */ c("div", { className: e, ...t, children: i });
}
export {
  u as Container
};
